import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceDisplay = _resolveComponent("PriceDisplay")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_HeightDeployer = _resolveComponent("HeightDeployer")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          (!_ctx.hidePriceDetails)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "ma-0 pa-4 pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0 my-auto fit-content" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "ma-0 token-text-medium token-text-color-primary" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceDisplay, {
                            price: _ctx.totalPriceMin,
                            price2: _ctx.totalPriceMax,
                            currency: _ctx.currency
                          }, null, 8, ["price", "price2", "currency"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "pa-0 my-auto ml-auto fit-content" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "token-text-medium token-text-color-secondary" }, " Price details ", -1)),
                          _createVNode(_component_CustomButton, {
                            class: "ml-2 my-auto",
                            level: _ctx.$enums.ButtonLevels.SmallIcon,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.priceDetailDeployed = !_ctx.priceDetailDeployed))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Icon, {
                                icon: "caret-down",
                                class: _normalizeClass(["caret", {invert : _ctx.priceDetailDeployed}])
                              }, null, 8, ["class"])
                            ]),
                            _: 1
                          }, 8, ["level"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_HeightDeployer, {
            modelValue: _ctx.priceDetailDeployed,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceDetailDeployed) = $event)),
            class: "full-width"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "ma-0 mx-4 token-text-regular" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pa-0 my-auto fit-content" }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Worker nodes ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 my-auto mx-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Divider)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 ml-auto fit-content" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_PriceDisplay, {
                                price: _ctx.clusterNodeTypologies.length ? _ctx.minPriceWorkerNodes : null,
                                price2: _ctx.maxPriceWorkerNodes,
                                currency: _ctx.currency,
                                disableBurger: true
                              }, null, 8, ["price", "price2", "currency"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pa-0 my-auto fit-content" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "ma-0" }, {
                                default: _withCtx(() => [
                                  _cache[8] || (_cache[8] = _createElementVNode("div", null, "Control nodes", -1)),
                                  _createVNode(_component_Tooltip, {
                                    class: "ml-2",
                                    docLink: "guides/cluster-configuration/#defining-the-number-of-nodes"
                                  }, {
                                    header: _withCtx(() => _cache[6] || (_cache[6] = [
                                      _createTextVNode(" Control nodes are added ")
                                    ])),
                                    content: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode(" Starting at 2 nodes, we add dedicated nodes to manage the workload on your cluster."),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" They are added to improve reliability and stability and while fully managed by Fransys, they increase the overall cost of your cluster. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 my-auto mx-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Divider)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 ml-auto fit-content" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_PriceDisplay, {
                                price: _ctx.providerRequirements.length ? _ctx.minPriceMasterNodes : null,
                                price2: _ctx.maxPriceMasterNodes,
                                currency: _ctx.currency,
                                disableBurger: true
                              }, null, 8, ["price", "price2", "currency"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pa-0 my-auto fit-content" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "ma-0" }, {
                                default: _withCtx(() => [
                                  _cache[11] || (_cache[11] = _createElementVNode("div", null, "Load balancer", -1)),
                                  _createVNode(_component_Tooltip, { class: "ml-2" }, {
                                    header: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode(" A load balancer is added ")
                                    ])),
                                    content: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createTextVNode(" Starting at 2 nodes, we add a load balancer in front of your cluster."),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" It is fully managed by Fransys and is here to better balance your traffic and improve reliability. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 my-auto mx-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Divider)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "pa-0 ml-auto fit-content" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_PriceDisplay, {
                                price: _ctx.providerRequirements.length ? _ctx.minPriceLoadBalancer : null,
                                price2: _ctx.maxPriceLoadBalancer,
                                currency: _ctx.currency,
                                disableBurger: true
                              }, null, 8, ["price", "price2", "currency"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (!_ctx.hidePriceDetails)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                class: "pa-0 mt-2 my-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Divider)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, { class: "pa-2 ma-0 flex" }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomButton, {
                level: _ctx.$enums.ButtonLevels.Secondary,
                text: "Provider / Location",
                icon: "caret-left",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('previous')))
              }, null, 8, ["level"]),
              _createVNode(_component_CustomButton, {
                class: "ml-auto",
                level: _ctx.$enums.ButtonLevels.Primary,
                text: 'Deploy cluster',
                icon: 'publish',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('publish'))),
                status: _ctx.publishState,
                loading: _ctx.publishLoading,
                disabled: _ctx.publishDisabled
              }, null, 8, ["level", "status", "loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}